import ShareableLinkNdaCountersign from './ShareableLinkNdaCountersign.component';

export default ShareableLinkNdaCountersign;